var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hold-switch-header',{attrs:{"completion-date":_vm.completionDate,"switch-id":_vm.customerId,"is-hold-switch":_vm.isHoldSwitch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }